import React, { useEffect, useState } from 'react'
import { date } from '../../../utils/date'
import { AiTwotoneEdit } from 'react-icons/ai'
import { convertMinutesToHoursMinutes } from '../../../utils/timeUtils'
import Input from '../../ui/input/input'
import { BsArrowRepeat } from 'react-icons/bs'
import { MdDeleteForever } from "react-icons/md";
import usePosition from '../../../hooks/position.hook'
import { useNotification } from '../../../hooks/notification.hook'


export const CustomWorkItem = ({data, userId, setDeleteModal, positionId, getData}) => {
  const {readableTime, workAddDate, workTitle, id: workId, workMinutes} = data
  const {editCustomWork} = usePosition()
  const notification = useNotification()
  const {hours, minutes} = convertMinutesToHoursMinutes(workMinutes)

  const [editMode, setEditMode] = useState(false)
  const [workData, setWorkData] = useState({hours, minutes, userId, workId, workTitle})

  const dateFormated = date.transform(workAddDate, false)

  const onChangeFormData = (value, key) => {
    setWorkData({ ...workData, [key]: value })
  }

  const onEditCustomWork = async () => {
    const data = {
      workId,
      workTitle: workData.workTitle,
      workMinutes: (Number(workData.hours || 0) * 60) + Number(workData.minutes || 0),
      readableTime: `${workData.hours || 0} ч. ${workData.minutes && !['0', '00'].includes(workData.minutes)
        ? `${Number(workData.minutes)} мин.`
        : ''}`.trim()
    }
    const res = await editCustomWork(data)
    if(res.status === 200) {
      await getData()
      notification('Запись изменена', 'success')
    }
  }
  const onDeleteCustomWork = () => {
    setDeleteModal({isOpen: true, workId})
  }

  return (
    <div className={`flex flex-col gap-[12px] ${editMode ? '' : ''}`}>
      <div className={`flex gap-[12px]`}>
        <div>{dateFormated}:</div>
        <div className={`font-bold`}>{workTitle}</div>
        <div className={`font-bold`}>{readableTime}</div>
        <span className={`hover:cursor-pointer hover:text-Accent/Blue`} onClick={() => setEditMode(!editMode)}>
          <AiTwotoneEdit />
        </span>
      </div>
      {editMode && <div className={`grid grid-cols-[4fr_1fr_1fr_auto]`}>
        <Input
          label={'Работа'}
          type='text'
          onInput={({ target: { value } }) => onChangeFormData(value, 'workTitle')}
          placeholder='Введите название работы'
          initial={workData.workTitle}></Input>
        <Input
          label={'Часы'}
          type='number'
          onInput={({ target: { value } }) => onChangeFormData(value, 'hours')}
          placeholder='Часы'
          maxValue={24}
          maxLength={2}
          initial={workData.hours}></Input>
        <Input
          label={'Минуты'}
          type='number'
          onInput={({ target: { value } }) => onChangeFormData(value, 'minutes')}
          placeholder='Минуты'
          maxValue={59}
          maxLength={2}
          initial={workData.minutes}></Input>
        <div className={`flex items-center justify-center gap-[12px] pl-[8px] mt-[20px]`}>
            <span className={`text-Regular(24_30) hover:cursor-pointer pointer hover:text-Accent/Blue 
              ${workData.workTitle && (workData.hours || workData.minutes) ? '' : 'pointer-events-none opacity-50'}`} onClick={onEditCustomWork}>
              <BsArrowRepeat/>
            </span>
            <span className={`text-Regular(24_30) hover:cursor-pointer hover:text-Accent/Red`} onClick={onDeleteCustomWork}>
              <MdDeleteForever />
            </span>
        </div>
      </div>
      }
    </div>

  )
}